import type { Locale } from "@/lib/i18n/dictionary";

export const LOCALE_KEY = "myapi_locale";
export const THEME_KEY = "myapi_theme";
export const LOCALE_COOKIE = "myapi_locale";
export const BOOT_CLASS = "prefs-booting";
export type Theme = "light" | "dark";

export function detectLocale(): Locale {
  if (typeof navigator === "undefined") return "en";
  return (navigator.language || "").toLowerCase().startsWith("he") ? "he" : "en";
}

export function detectTheme(): Theme {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function readStoredPrefs(): { locale: Locale; theme: Theme } {
  if (typeof window === "undefined") return { locale: "en", theme: "light" };
  const storedLocale = localStorage.getItem(LOCALE_KEY);
  const storedTheme = localStorage.getItem(THEME_KEY);
  const locale: Locale =
    storedLocale === "he" || storedLocale === "en" ? storedLocale : detectLocale();
  const theme: Theme =
    storedTheme === "dark" || storedTheme === "light" ? storedTheme : detectTheme();
  return { locale, theme };
}

export function dismissBootSplash() {
  if (typeof document === "undefined") return;
  document.documentElement.classList.remove(BOOT_CLASS);
}

/**
 * Before paint: set lang/theme and add the boot class (splash is CSS-only, see globals.css).
 * Failsafe clears after 1.2s even if React never mounts.
 */
export const PREFS_BOOT_SCRIPT = `(function(){var d=document.documentElement,B='${BOOT_CLASS}';function clear(){d.classList.remove(B);}window.__MYAPI_CLEAR_BOOT__=clear;setTimeout(clear,1200);try{var L='${LOCALE_KEY}',T='${THEME_KEY}',C='${LOCALE_COOKIE}';var l=localStorage.getItem(L);if(l!=='he'&&l!=='en'){l=((navigator.language||'').toLowerCase().indexOf('he')===0)?'he':'en';localStorage.setItem(L,l);}var t=localStorage.getItem(T);if(t!=='dark'&&t!=='light'){t=window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light';localStorage.setItem(T,t);}d.lang=l;d.dir=l==='he'?'rtl':'ltr';d.classList.toggle('dark',t==='dark');d.classList.add(B);document.cookie=C+'='+l+';Path=/;Max-Age=31536000;SameSite=Lax';window.__MYAPI_PREFS__={locale:l,theme:t};}catch(e){clear();}})();`;